<app-dashboard-card
	[title]="title"
	[subtitle]="summaryText"
	icon="pi pi-exclamation-triangle"
>
	<div *ngIf="loading" class="dashboard-state">
		Loading risk summary...
	</div>

	<div
		*ngIf="!loading && error"
		class="dashboard-state dashboard-state-error"
	>
		Unable to load risk summary.
	</div>

	<div
		*ngIf="!loading && !error && dataStatus === 'WAITING'"
		class="dashboard-state"
	>
		Risk processing is still in progress for the selected period.
	</div>

	<div
		*ngIf="!loading && !error && dataStatus === 'UNAVAILABLE'"
		class="dashboard-state"
	>
		Risk data is unavailable for the selected period.
	</div>

	<ng-container
		*ngIf="
			!loading &&
			!error &&
			dataStatus !== 'WAITING' &&
			dataStatus !== 'UNAVAILABLE' &&
			summary
		"
	>
		<div
			*ngIf="dataStatus === 'PARTIAL'"
			class="risk-partial-notice"
		>
			<i class="pi pi-info-circle"></i>

			<span>
				Some report data is incomplete for the selected period.
			</span>
		</div>

		<div
			*ngIf="summary.reportTypes.length === 0"
			class="dashboard-state"
		>
			No risks were identified for the selected period.
		</div>

		<div
			*ngIf="summary.reportTypes.length > 0"
			class="risk-table-wrapper"
		>
			<table class="risk-table">
				<thead>
				<tr>
					<th>Report</th>
					<th>Severity</th>
					<th>{{ isMultiDayPeriod ? 'Avg Risk Value' : 'Risk Value' }}</th>
					<th>View</th>
				</tr>
				</thead>

				<tbody>
				<tr *ngFor="let report of visibleReportTypes">
					<td class="risk-report-name">
						{{ report.reportTypeName }}
					</td>

					<td>
							<span
								class="risk-severity"
								[ngClass]="
									getSeverityClass(report.highestSeverity)
								"
							>
								{{ report.highestSeverity || '—' }}
							</span>
					</td>

					<td class="risk-value-cell">
						<!-- Financial takes precedence.
								 Never display financial and operational together. -->

						<span
							*ngIf="isFinancialReport(report)"
							class="risk-value-financial"
						>
								{{ formatCurrency(report.totalRiskValue) }}
							</span>

						<span
							*ngIf="isOperationalReport(report)"
							class="risk-value-operational"
						>
								{{
								formatOperationalRisks(
									report.operationsRiskCount
								)
							}}
							</span>

						<span
							*ngIf="
									!isFinancialReport(report) &&
									!isOperationalReport(report)
								"
							class="text-color-secondary"
						>
								—
							</span>
					</td>

                    <td class="risk-view-cell">
                        <button
                                *ngIf="
			isMultiDayPeriod ||
			report.taskInstanceId !== null
		"
                                type="button"
                                class="risk-view-link"
                                (click)="onViewReport(report)"
                        >
                            View
                        </button>

                        <span
                                *ngIf="
			!isMultiDayPeriod &&
			report.taskInstanceId === null &&
			report.affectedTaskCount > 1
		"
                                class="text-color-secondary text-sm"
                        >
		{{ report.affectedTaskCount }} tasks
	</span>

                        <span
                                *ngIf="
			!isMultiDayPeriod &&
			report.taskInstanceId === null &&
			report.affectedTaskCount <= 1
		"
                                class="text-color-secondary"
                        >
		—
	</span>
                    </td>
				</tr>
				</tbody>
			</table>
		</div>

		<div
			*ngIf="hasMoreReports"
			class="risk-summary-expand"
		>
			<button
				type="button"
				class="risk-summary-expand-link"
				(click)="toggleExpanded()"
			>
				{{ expanded ? 'Show less' : 'Show all' }}

				<i
					class="pi"
					[ngClass]="
						expanded
							? 'pi-chevron-up'
							: 'pi-chevron-down'
					"
				></i>
			</button>
		</div>
	</ng-container>
</app-dashboard-card>
